import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fixed-header" }
const _hoisted_2 = { class: "flex items-center justify-center pt-16 mb-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center mb-6 px-5"
}
const _hoisted_5 = { class: "text-base2 text-white" }
const _hoisted_6 = { class: "text-base2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "content-container" }
const _hoisted_9 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_10 = { class: "empty-text" }
const _hoisted_11 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "card-image-container" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 0,
  class: "unbooked-badge"
}
const _hoisted_16 = { class: "unbooked-badge-text" }
const _hoisted_17 = {
  key: 1,
  class: "time-banner"
}
const _hoisted_18 = { class: "time-banner-text" }
const _hoisted_19 = {
  key: 2,
  class: "time-banner"
}
const _hoisted_20 = { class: "time-banner-text" }
const _hoisted_21 = {
  key: 3,
  class: "date-badge"
}
const _hoisted_22 = { class: "date-day" }
const _hoisted_23 = { class: "date-month" }
const _hoisted_24 = { class: "card-content" }
const _hoisted_25 = { class: "card-title" }
const _hoisted_26 = { class: "info-row" }
const _hoisted_27 = { class: "info-text" }
const _hoisted_28 = { class: "info-bold" }
const _hoisted_29 = { class: "info-row" }
const _hoisted_30 = { class: "info-text" }
const _hoisted_31 = { class: "info-bold" }
const _hoisted_32 = { class: "info-row" }
const _hoisted_33 = { class: "info-text" }
const _hoisted_34 = { class: "info-bold" }
const _hoisted_35 = { class: "info-row" }
const _hoisted_36 = { class: "info-text" }
const _hoisted_37 = { class: "info-bold" }
const _hoisted_38 = { class: "info-light pl-1" }
const _hoisted_39 = {
  key: 2,
  class: "info-row"
}
const _hoisted_40 = { class: "info-text" }
const _hoisted_41 = { class: "info-light" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "action-buttons" }
const _hoisted_44 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_45 = { class: "empty-text" }
const _hoisted_46 = { class: "empty-subtext" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { IonContent, IonFooter, IonButton, IonIcon, IonSpinner, IonRefresher, IonRefresherContent, RefresherCustomEvent } from '@ionic/vue';
import { time } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';

import NavigationBar from '@/shared/components/ui/NavigationBar.vue';
import useQueue from '@/modules/queue/composables/useQueue';
import { useAuthStore } from '@/stores/auth/authStore';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import { useCacheImage } from '@/shared/composables/useCacheImage';

// Init

export default /*@__PURE__*/_defineComponent({
  __name: 'MyQueuesPage',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const authStore = useAuthStore();
const assetStore = useAssetsStore();
const { loadImage } = useCacheImage();
const logoUrl = ref(assetStore.logoUrl);

// Load logo
if (assetStore.logoUrl) {
	let logoImage = assetStore.logoUrl.split('/').pop();
	logoImage = logoImage ?? 'logo';
	loadImage('logo', logoImage, assetStore.logoUrl).then(url => logoUrl.value = url);
}

// Queue composable
const { getMyQueues, getUnbookedQueueActivities, formatWaitTime } = useQueue();
const { myQueues, isFetchingMyQueues, refetchMyQueues } = getMyQueues();
const { unbookedActivities, isFetchingUnbookedActivities, refetchUnbookedActivities } = getUnbookedQueueActivities();

// Computed queues based on status
const activeQueues = computed(() => {
	return myQueues.value?.filter(slot =>
		['active', 'waiting', 'called', 'in_progress'].includes(slot.status)
	) || [];
});

// Group slots by activity and date, show one entry per activity per date
// Sorted by date (earliest first) and estimated wait time (shortest first)
// Also includes unbooked activities formatted as queue-like items
const uniqueActivityQueues = computed(() => {
	const seen = new Map();
	const result: any[] = [];

	// Add booked slots
	activeQueues.value.forEach(slot => {
		// Get activity ID from slot (try queue_activity.id first, then sub_activity.queue_activity_id)
		const activityId = slot.queue_activity?.id || slot.sub_activity?.queue_activity_id;
		const bookedDate = slot.booked_date;
		const key = `${activityId}_${bookedDate}`;
		if (activityId && !seen.has(key)) {
			seen.set(key, slot);
			result.push(slot);
		}
	});

	// Add unbooked activities formatted as queue-like items
	if (unbookedActivities.value) {
		unbookedActivities.value.forEach(unbooked => {
			const activityId = unbooked.queue_activity_id;
			const key = `unbooked_${activityId}`;
			if (!seen.has(key)) {
				seen.set(key, true);
			// Format as a queue-like item
			const unbookedItem = {
				id: `unbooked_${activityId}`, // Use a unique ID
				queue_activity_id: activityId,
				queue_activity: unbooked.queue_activity,
				is_unbooked: true,
				count: unbooked.count,
				event_ticket_ids: unbooked.event_tickets.map(t => t.id),
				queue_types: unbooked.event_tickets.map(t => t.queue_type || 'normal'),
				status: 'unbooked',
				created_at: new Date().toISOString(), // Use current date for sorting
			};
				result.push(unbookedItem);
			}
		});
	}

	// Sort by unbooked status first (unbooked items go first), then by date (earliest first), then by estimated wait time (shortest first)
	result.sort((a, b) => {
		// Unbooked items go FIRST (before booked items)
		if (a.is_unbooked && !b.is_unbooked) return -1;
		if (!a.is_unbooked && b.is_unbooked) return 1;

		// Get dates for comparison (use booked_date or created_at)
		const dateA = new Date(a.booked_date || a.created_at).getTime();
		const dateB = new Date(b.booked_date || b.created_at).getTime();

		// First, sort by date (earliest first)
		if (dateA !== dateB) {
			return dateA - dateB;
		}

		// If dates are the same, sort by estimated wait time (shortest first)
		const waitTimeA = a.timing?.estimated_wait_minutes || a.estimated_wait_minutes || 0;
		const waitTimeB = b.timing?.estimated_wait_minutes || b.estimated_wait_minutes || 0;
		return waitTimeA - waitTimeB;
	});

	return result;
});

// Computed queue count (total number of slots, not unique activities)
const myQueuesCount = computed(() => activeQueues.value.length);

// Pull to refresh
const handleRefresh = async (event: RefresherCustomEvent) => {
	await refetchMyQueues();
	await refetchUnbookedActivities();
	event.target.complete();
};

// Navigate to ticket detail
const goToTicket = (slotId: number) => {
	router.push(`/queue/ticket/${slotId}`);
};

// Navigate to unbooked activity date selection
const goToUnbookedActivity = (activityId: number, eventTicketIds: number[], queueTypes: string[] = []) => {
	// Store event ticket IDs and queue types in session storage
	sessionStorage.setItem('unbooked_event_ticket_ids', JSON.stringify(eventTicketIds));
	if (queueTypes.length > 0) {
		sessionStorage.setItem('unbooked_queue_types', JSON.stringify(queueTypes));
	}
	router.push(`/queue/${activityId}/date-selection?from_unbooked=true`);
};

// Navigate to activities
const goToActivities = () => {
	router.push('/queue');
};

// Format date for badge
const formatDateBadge = (dateString: string) => {
	const date = new Date(dateString);
	return {
		day: date.getDate(),
		month: date.toLocaleDateString('en-US', { month: 'short' })
	};
};

// Get queue type badge info
const getQueueTypeBadge = (queueType: string) => {
	if (queueType === 'fastlane') {
		return {
			text: t('queue.fastlane'),
			emoji: '⭐️',
		};
	}
	return null;
};

// Format position text
const getPositionText = (slot: any) => {
	const badge = getQueueTypeBadge(slot.queue_type);
	if (badge) {
		return `${t('queue.position')} ${slot.position_number} in the ${badge.emoji} ${badge.text} ${badge.emoji}`;
	}
	return `${t('queue.position')} ${slot.position_number} in the ${t('queue.waiting_line')}`;
};

// Get wait time for banner
const getWaitTimeBanner = (slot: any) => {
	const minutes = slot.timing?.estimated_wait_minutes || slot.estimated_wait_minutes || 0;
	if (minutes < 60) {
		return `${minutes} ${t('queue.minutes')}`;
	}
	const hours = Math.floor(minutes / 60);
	const remainingMins = minutes % 60;
	if (remainingMins === 0) {
		return `${hours}h`;
	}
	return t('queue.hours_minutes_wait', { hours, minutes: remainingMins });
};

// Check if slot is a timeslot-based queue
const isTimeSlotQueue = (slot: any) => {
	const activity = slot.queue_activity || slot.sub_activity?.queue_activity;
	return activity?.queue_type === 'time_slot';
};

// Format timeslot for display (e.g. "19:00 - 19:30")
const formatTimeSlot = (slot: any) => {
	const ts = slot.booked_time_slot;
	if (!ts) return '';

	// If already in range format "HH:MM-HH:MM"
	if (typeof ts === 'string' && ts.includes('-') && !ts.includes('T')) {
		return ts.replace('-', ' - ');
	}

	// Parse ISO or "HH:MM:SS" format
	let startTime: string;
	if (typeof ts === 'string' && ts.includes('T')) {
		const d = new Date(ts);
		startTime = d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
	} else {
		startTime = ts.substring(0, 5);
	}

	// Calculate end time from cycle duration if available
	const activity = slot.queue_activity || slot.sub_activity?.queue_activity;
	if (activity?.cycle_duration_minutes) {
		const [h, m] = startTime.split(':').map(Number);
		const endDate = new Date(2000, 0, 1, h, m + activity.cycle_duration_minutes);
		const endTime = endDate.getHours().toString().padStart(2, '0') + ':' + endDate.getMinutes().toString().padStart(2, '0');
		return `${startTime} - ${endTime}`;
	}

	return startTime;
};

// Format timeslot start time only (e.g. "18:27") for the banner
const formatTimeSlotStart = (slot: any) => {
	const ts = slot.booked_time_slot;
	if (!ts) return '';

	if (typeof ts === 'string' && ts.includes('T')) {
		const d = new Date(ts);
		return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
	}

	// "HH:MM:SS" or "HH:MM-HH:MM"
	return ts.substring(0, 5);
};

// Format date as dd.mm.yyyy
const formatDateShort = (dateString: string) => {
	const d = new Date(dateString);
	const day = d.getUTCDate().toString().padStart(2, '0');
	const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
	const year = d.getUTCFullYear();
	return `${day}.${month}.${year}`;
};

// Check if booked timeslot has passed
const isTimeslotPassed = (slot: any) => {
	// Only check for time_slot queue types
	const activity = slot.queue_activity || slot.sub_activity?.queue_activity;
	const isTimeSlot = activity?.queue_type === 'time_slot' && !!slot.booked_time_slot;

	if (!isTimeSlot) {
		return false; // Not a time slot booking, so not applicable
	}

	const timeslot = slot.booked_time_slot;
	const bookedDate = slot.booked_date;

	if (!timeslot || !bookedDate) {
		return false; // No timeslot info, allow fastpass
	}

	try {
		// First, check if the booked date itself is in the past
		const bookedDateObj = new Date(bookedDate);
		const today = new Date();
		today.setHours(0, 0, 0, 0); // Reset to start of today for comparison
		bookedDateObj.setHours(0, 0, 0, 0); // Reset to start of booked date for comparison

		// If booked date is before today, the timeslot has definitely passed
		if (bookedDateObj < today) {
			return true;
		}

		// If booked date is in the future, the timeslot hasn't passed
		if (bookedDateObj > today) {
			return false;
		}

		// If booked date is today, check if the end time has passed
		let endTime: Date | null = null;

		// Check if timeslot is a UTC datetime string (e.g., "2025-10-31T09:00:00.000000Z")
		const isUtcDateTime = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(timeslot.trim());

		if (isUtcDateTime) {
			// Parse UTC datetime
			const utcDate = new Date(timeslot);
			if (!isNaN(utcDate.getTime())) {
				// Calculate end time from cycle duration
				if (activity && activity.cycle_duration_minutes) {
					endTime = new Date(utcDate.getTime() + activity.cycle_duration_minutes * 60000);
				} else {
					endTime = utcDate; // Use start time as end time if no cycle duration
				}
			}
		} else {
			// Parse time string format (e.g., "10:00", "10:00-11:00")
			const allTimeMatches = timeslot.match(/(\d{1,2}:\d{2})(?::\d{2})?/g);

			if (allTimeMatches && allTimeMatches.length >= 2) {
				// Has both start and end times (e.g., "10:00-11:00")
				const endTimeStr = allTimeMatches[allTimeMatches.length - 1].substring(0, 5);
				const [hours, minutes] = endTimeStr.split(':').map(Number);
				const slotDate = new Date(bookedDate);
				slotDate.setHours(hours, minutes, 0, 0);
				endTime = slotDate;
			} else if (allTimeMatches && allTimeMatches.length === 1) {
				// Single time found, calculate end time from cycle duration
				const startTimeStr = allTimeMatches[0].substring(0, 5);
				const [hours, minutes] = startTimeStr.split(':').map(Number);
				const slotDate = new Date(bookedDate);
				slotDate.setHours(hours, minutes, 0, 0);

				if (activity && activity.cycle_duration_minutes) {
					endTime = new Date(slotDate.getTime() + activity.cycle_duration_minutes * 60000);
				} else {
					endTime = slotDate; // Use start time as end time if no cycle duration
				}
			}
		}

		// Check if end time has passed (only if we're checking today's timeslot)
		if (endTime) {
			return endTime < new Date();
		}

		return false; // Couldn't parse timeslot, allow fastpass
	} catch (error) {
		console.error('Error checking if timeslot has passed:', error);
		return false; // On error, allow fastpass to be safe
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), { class: "my-queues-page" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonRefresher), {
          slot: "fixed",
          onIonRefresh: _cache[0] || (_cache[0] = ($event: any) => (handleRefresh($event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRefresherContent))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: logoUrl.value,
              class: "max-w-[180px]"
            }, null, 8, _hoisted_3)
          ]),
          (_unref(authStore).isAuthenticated())
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(IonButton), {
                  class: "mr-2 w-[140px] h-[40px] button-solid rounded-full backdrop-blur bg-white/20 hover:bg-white/20",
                  shape: "round",
                  fill: "clear",
                  onClick: goToActivities
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('queue.activities')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonButton), {
                  class: "w-[140px] h-[40px] button-solid rounded-full hover:bg-white",
                  shape: "round",
                  fill: "default"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_unref(t)('queue.my_queues')) + " ", 1),
                      (myQueuesCount.value > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(myQueuesCount.value) + ")", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (!_unref(authStore).isAuthenticated())
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('queue.login_to_view_queues')), 1),
                _createVNode(_unref(IonButton), {
                  fill: "outline",
                  "router-link": "/auth/login",
                  class: "action-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('auth.login')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_unref(isFetchingMyQueues) || _unref(isFetchingUnbookedActivities))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_unref(IonSpinner), { name: "circular" })
                ]))
              : (uniqueActivityQueues.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["queue-cards", { 'single-card': uniqueActivityQueues.value.length === 1 }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniqueActivityQueues.value, (slot) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: slot.id,
                        class: _normalizeClass(["queue-card", { 'unbooked-card': slot.is_unbooked }]),
                        onClick: ($event: any) => (slot.is_unbooked ? goToUnbookedActivity(slot.queue_activity_id, slot.event_ticket_ids, slot.queue_types) : goToTicket(slot.id))
                      }, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("img", {
                            src: slot.queue_activity?.main_image || slot.queue_activity?.main_image_url || '/assets/placeholder.jpg',
                            alt: slot.queue_activity?.name,
                            class: "card-image"
                          }, null, 8, _hoisted_14),
                          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-image-gradient" }, null, -1)),
                          (slot.is_unbooked)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(slot.count) + " " + _toDisplayString(slot.count === 1 ? 'ticket' : 'tickets') + " to book", 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!slot.is_unbooked && !isTimeSlotQueue(slot))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(getWaitTimeBanner(slot)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!slot.is_unbooked && isTimeSlotQueue(slot))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(formatTimeSlotStart(slot)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!slot.is_unbooked)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(formatDateBadge(slot.booked_date || slot.created_at).day), 1),
                                _createElementVNode("div", _hoisted_23, _toDisplayString(formatDateBadge(slot.booked_date || slot.created_at).month), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("h3", _hoisted_25, _toDisplayString(slot.queue_activity?.name || _unref(t)('queue.activity')), 1),
                          (!slot.is_unbooked && isTimeSlotQueue(slot))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(time),
                                    class: "info-icon"
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("p", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(formatDateShort(slot.booked_date)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(time),
                                    class: "info-icon"
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("p", _hoisted_30, [
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(formatTimeSlot(slot)), 1)
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (!slot.is_unbooked && !isTimeSlotQueue(slot))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(time),
                                    class: "info-icon"
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("p", _hoisted_33, [
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(getPositionText(slot)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(time),
                                    class: "info-icon"
                                  }, null, 8, ["icon"]),
                                  _createElementVNode("p", _hoisted_36, [
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(formatWaitTime)(slot.timing?.estimated_wait_minutes || slot.estimated_wait_minutes)), 1),
                                    _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('queue.estimated_waiting_time')), 1)
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (slot.is_unbooked)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("p", _hoisted_40, [
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('queue.select_date_time_to_book')), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "separator" }, null, -1)),
                          _createElementVNode("p", {
                            class: "card-description",
                            innerHTML: slot.queue_activity?.short_description || slot.queue_activity?.description?.substring(0, 100) || _unref(t)('queue.no_description')
                          }, null, 8, _hoisted_42),
                          _createElementVNode("div", _hoisted_43, [
                            (slot.is_unbooked)
                              ? (_openBlock(), _createBlock(_unref(IonButton), {
                                  key: 0,
                                  fill: "solid",
                                  expand: "block",
                                  class: "book-button",
                                  onClick: _withModifiers(($event: any) => (goToUnbookedActivity(slot.queue_activity_id, slot.event_ticket_ids, slot.queue_types)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('queue.book_now')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_unref(IonButton), {
                                  key: 1,
                                  fill: "outline",
                                  expand: "block",
                                  class: "view-spot-button",
                                  onClick: _withModifiers(($event: any) => (goToTicket(slot.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('queue.view_spot')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])),
                            (!slot.is_unbooked && slot.queue_type === 'normal' && slot.queue_activity?.upsell_price && slot.queue_activity?.upsellCurrency && slot.fastlane_available !== false && slot.status !== 'completed' && !isTimeslotPassed(slot))
                              ? (_openBlock(), _createBlock(_unref(IonButton), {
                                  key: 2,
                                  fill: "solid",
                                  expand: "block",
                                  class: "fastpass-button",
                                  onClick: _withModifiers(($event: any) => (goToTicket(slot.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('queue.buy_fastpass')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 10, _hoisted_12))
                    }), 128))
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(t)('queue.no_active_queues')), 1),
                    _createElementVNode("p", _hoisted_46, _toDisplayString(_unref(t)('queue.browse_activities_to_join')), 1),
                    _createVNode(_unref(IonButton), {
                      fill: "outline",
                      onClick: goToActivities,
                      class: "action-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('queue.browse_activities')), 1)
                      ]),
                      _: 1
                    })
                  ]))
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-[100px]" }, " ", -1))
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), null, {
      default: _withCtx(() => [
        _createVNode(NavigationBar, { "item-active": "queue" })
      ]),
      _: 1
    })
  ], 64))
}
}

})